import script from "./SinMartilleroModal.vue?vue&type=script&setup=true&lang=js"
export * from "./SinMartilleroModal.vue?vue&type=script&setup=true&lang=js"

import "./SinMartilleroModal.vue?vue&type=style&index=0&id=424f40c4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-424f40c4"]])

export default __exports__